import axios from 'axios';
import { Config, HTTPResponse } from '../types/types.system';
import notify from 'devextreme/ui/notify'
import { formatMessage } from 'devextreme/localization';
import { useAppSelector } from '../contexts/hooks';



const useApi = () => {
    const token = useAppSelector(data => data.userInfo.Token);
    const ShowToast = (message: string, type: 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR') => {
        notify({
            message,
            type,
            displayTime: 7000,
            closeOnClick: true,
            animation: {
                show: {
                    type: 'fade', duration: 400, from: 0, to: 1,
                },
                hide: { type: 'fade', duration: 40, to: 0 },
            },
        },
            {
                position: 'bottom right',
                direction: 'up-stack'
            })
    }

    const runApi = async (url: string, method: 'GET' | 'POST', params?: any, data?: any) => {
        const configUrl = '/config.json';
        const configResponse = await fetch(configUrl);
        const config: Config = await configResponse.json();
        const apiUrl = `${config.apiUrl}/api/${url}`;
        const headers = {
            Authorization: token,
        };
        try {
            const response = await axios({
                url: apiUrl,
                method,
                params,
                data,
                headers,
            }).then(res => {
                return res.data
            }).catch(err => {
                console.log(err)
                if (axios.isAxiosError(err)) {
                    if (err.response) {
                        const resp = err.response.data as HTTPResponse;
                        ShowToast(resp.message, resp.internalCode < 500 ? 'WARNING' : 'ERROR');
                        return resp
                    }
                }
                ShowToast(formatMessage('Error500Details'), 'ERROR');
                return { httpCode: 504, internalCode: 504, message: formatMessage('Error500Details'), messageHeader: null, warnings: null, messageDetails: null, data: null } as HTTPResponse
            });

            return response as HTTPResponse;
        } catch (error) {
            ShowToast(formatMessage('Error500Details'), 'ERROR');
            console.log(error)
            return { httpCode: 504, internalCode: 505, message: formatMessage('Error500Details'), messageHeader: null, warnings: null, messageDetails: null, data: null } as HTTPResponse
        }
    };

    const runApiFormData = async (url: string, formData: FormData) => {
        const configUrl = '/config.json';
        const configResponse = await fetch(configUrl);
        const config: Config = await configResponse.json();
        const apiUrl = `${config.apiUrl}/api/${url}`;
      
        const headers = {
          Authorization: token,
          'Content-Type': 'multipart/form-data',
        };
      
        try {
          const response = await axios.post(apiUrl, formData, { headers });
          return response.data as HTTPResponse;
        } catch (error) {
          if (axios.isAxiosError(error) && error.response) {
            const resp = error.response.data as HTTPResponse;
            ShowToast(resp.message, resp.internalCode < 500 ? 'WARNING' : 'ERROR');
            return resp;
          }
          ShowToast(formatMessage('Error500Details'), 'ERROR');
          return {
            httpCode: 504,
            internalCode: 504,
            message: formatMessage('Error500Details'),
            messageHeader: null,
            warnings: null,
            messageDetails: null,
            data: null,
          } as HTTPResponse;
        }
      };
      

    return { runApi, runApiFormData }
}

///Corre la api sin token, si requiere usar token, corra custom hook
export const runApWithoutToken = async (url: string, method: 'GET' | 'POST', params?: any, data?: any) => {
    const configUrl = '/config.json';
    const configResponse = await fetch(configUrl);
    const config: Config = await configResponse.json();
    const apiUrl = `${config.apiUrl}/api/${url}`;

    try {
        const response = await axios({
            url: apiUrl,
            method,
            params,
            data
        }).then(res => {
            return res.data
        }).catch(err => {
            console.log(err)
            if (axios.isAxiosError(err)) {
                if (err.response) {
                    const resp = err.response.data as HTTPResponse;
                    return resp
                }
            }
            return { httpCode: 504, internalCode: 504, message: formatMessage('Error500Details'), messageHeader: null, warnings: null, messageDetails: null, data: null } as HTTPResponse
        });

        return response as HTTPResponse;
    } catch (error) {
        return { httpCode: 504, internalCode: 505, message: formatMessage('Error500Details'), messageHeader: null, warnings: null, messageDetails: null, data: null } as HTTPResponse
    }
};


export default useApi;